import styled from 'styled-components';

export const ModalHeader = styled.div`
  background: ${(props) => props.theme.color.bg.secondary};
  svg {
    cursor: pointer;
  }
`;

export const ModalHeaderSection = styled.p`
  color: ${(props) => props.theme.color.text.secondary};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const ModalHeaderTitle = styled.h1`
  color: ${(props) => props.theme.color.text.inverse};
  font-family: Poppins;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const VideoContainer = styled.iframe`
  height: 640px;
  width: 100%;
`;

export const PageContainer = styled.div`
  height: 640px;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 60px;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  img {
    width: 320px;
    height: auto;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    text-align: center;
    color: ${(props) => props.theme.color.text.tertiary};
  }

  h4 {
    padding: 0 60px;
    text-align: center;
  }
`;

export const OptionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  /* background-color: red; */
  padding: 20px 30px 30px 0;
`;

export const SkipButton = styled.div`
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color: ${(props) => props.theme.color.text.disabled};
  cursor: pointer;
  display: flex;
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 38px;
  border-radius: 3px;
  border: 1px solid ${(props) => props.theme.color.ui.shade3};
  margin-right: 32px;
`;

export const NextButton = styled.div`
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  color: ${(props) => props.theme.color.text.inverse};
  cursor: pointer;
  display: flex;
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 38px;
  border-radius: 3px;
  border: 1px solid ${(props) => props.theme.color.ui.darkBlue};
  background: ${(props) => props.theme.color.bg.tertiary};
  margin-right: 32px;
  span {
    color: ${(props) => props.theme.color.text.inverse};
  }
  &.muted {
    opacity: 0.5;
  }
`;

export const ConclusionButton = styled.div`
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
  background-color: ${(props) => props.theme.color.ui.orange};
  color: ${(props) => props.theme.color.text.inverse};
  border-radius: 3px;
  border-width: 0;
  display: flex;
  height: 38px;
  padding: 0px 32px;
  justify-content: center;
  align-items: center;
  margin-right: 32px;
  span {
    color: ${(props) => props.theme.color.text.inverse};
  }
  gap: 10px;
  :hover {
    filter: brightness(0.95);
  }
`;
